import { render } from "./ProductList.vue?vue&type=template&id=74eb7651&scoped=true"
import script from "./ProductList.vue?vue&type=script&lang=js"
export * from "./ProductList.vue?vue&type=script&lang=js"

import "./ProductList.vue?vue&type=style&index=0&id=74eb7651&scoped=true&lang=css"

import exportComponent from "/Users/Zhuanz/Desktop/himoney/aidata/loan-management/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-74eb7651"]])

export default __exports__